import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { StartPageBlock } from '../../styles/blocks/StartPageBlock';
import { isValidHexColor } from '../../util/isValidHexColor';
import { color } from '../../styles/helpers/variables';

const HeroSection = props => {
  if (props.isMobile) {
    const isDark = isValidHexColor(props.backgroundColor) ? Color(props.backgroundColor).isDark() : false;

    return (
      <StartPageBlock.Section backgroundColor={props.backgroundColor} pt={0} pb={30}>
        <StartPageBlock.HeroImageContainer>
          <StartPageBlock.HeroImage image={props.heroImage} />
        </StartPageBlock.HeroImageContainer>

        <StartPageBlock.Container>
          <StartPageBlock.HeroHeading onDarkBackground={isDark}>{props.heroTitle}</StartPageBlock.HeroHeading>
          {props.heroLinkUrl ? (
            <StartPageBlock.HeroLink onDarkBackground={isDark} to={props.heroLinkUrl}>
              {props.heroLinkLabel}
            </StartPageBlock.HeroLink>
          ) : (
            false
          )}
        </StartPageBlock.Container>
      </StartPageBlock.Section>
    );
  }

  return (
    <StartPageBlock.Section backgroundColor={props.backgroundColor} pt={40} style={{ position: 'relative' }}>
      <StartPageBlock.SectionFix backgroundColor={color.lightGrey} />
      <StartPageBlock.Container>
        <StartPageBlock.HeroImageContainer>
          <StartPageBlock.HeroImage image={props.heroImage} />
          <StartPageBlock.HeroContentContainer alignRight={props.alignRight}>
            {props.heroLinkUrl ? (
              <StartPageBlock.HeroContent to={props.heroLinkUrl} isLight={props.heroBackgroundIsLight}>
                <StartPageBlock.HeroHeading isDark={!props.heroBackgroundIsLight}>
                  {props.heroTitle}
                </StartPageBlock.HeroHeading>
                <StartPageBlock.HeroLinkAsP isDark={!props.heroBackgroundIsLight}>
                  {props.heroLinkLabel}
                </StartPageBlock.HeroLinkAsP>
              </StartPageBlock.HeroContent>
            ) : (
              false
            )}
          </StartPageBlock.HeroContentContainer>
        </StartPageBlock.HeroImageContainer>
      </StartPageBlock.Container>
    </StartPageBlock.Section>
  );
};

HeroSection.defaultProps = {
  isMobile: false,
  backgroundColor: null,
  heroImage: null,
  heroTitle: null,
  heroLinkUrl: null,
  heroLinkLabel: null,
  alignRight: false,
  heroBackgroundIsLight: false
};

HeroSection.propTypes = {
  isMobile: PropTypes.bool,
  backgroundColor: PropTypes.string,
  heroImage: PropTypes.string,
  heroTitle: PropTypes.string,
  heroLinkUrl: PropTypes.string,
  heroLinkLabel: PropTypes.string,
  alignRight: PropTypes.bool,
  heroBackgroundIsLight: PropTypes.bool
};

export default HeroSection;



// WEBPACK FOOTER //
// ./src/components/StartPage/HeroSection.js